import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { TableColumn } from 'src/app/components/common/common-table/common-table.component';
import { InspectionsJanusService } from '../../inspections-janus.service';
import { WorkflowApplicationsJanusService } from '../../../workflow-applications/workflow-applications-janus/workflow-applications-janus.service';
import { DataService, WorkflowContextService, WorkflowService } from 'src/app/services';
import { ActivatedRoute } from '@angular/router';
import { LinkToApplicationModalData } from './link-to-application.modal';
import { CommonConfirmationModalData } from 'src/app/components/common/common-confirmation-modal/common-confirmation-modal.component.model';
import { LinkIconComponent } from './link-to-application-column.component';
import { GetApplicationsForLinkingRequest, LinkWorkflowApplicationRequest, UnlinkWorkflowApplicationRequest } from 'src/app/models/linked-application';

@Component({
  selector: 'app-link-to-application',
  standalone: false,
  templateUrl: './link-to-application.component.html',
  styleUrl: './link-to-application.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class LinkToApplicationComponent implements OnInit {
  @Input() applicationId = '';
  @Input() applicationNumber = '';
  @Input() applicationName = '';
  @Input() inspectionId = '';
  // columns: TableColumn[];
  selectedRow: any;
  // table data
  tableData: any[] = [];
  filteredData: any[] = [];
  data1: any[] = [];
  departmentId: string;
  allData: any[] = [];
  currentPage = 0;
  pageSize = 10;
  sortField = '';
  sortDescending = false;
  totalRecords = 0;// this is not ussing
  totalPages = 0;
  linkedApplicationId: string | null = null;

  deleteConfirmModal: CommonConfirmationModalData = {
    open: false,
    modalDescp: 'Are you sure you want to link this inspection?',
    modalSubDescp:
      'Clicking confirm will link this inspection to the selected application.',
    yesNoBtn: true,
    replaceYesWith: 'CONFIRM',
    replaceNoWith: 'CANCEL'
  };



  constructor(
    private dataService: DataService,
    private route: ActivatedRoute,
    private context: WorkflowContextService,
    private workflowSvc: WorkflowService,
  ) {

  }
  onSearch(event: any) {
    const searchValue = event.target.value.toLowerCase();
    this.currentPage = 1;
    // this.filteredData = this.tableData
    //   // .filter(item => item.applicationName === this.applicationName)
    //   .filter(item =>
    //     item.applicationNumber.toLowerCase().includes(searchValue) ||
    //     item.applicantName.toLowerCase().includes(searchValue) ||
    //     item.siteAddress.toLowerCase().includes(searchValue) ||
    //     item.applicantPhoneNumber.toLowerCase().includes(searchValue) ||
    //     item.applicantEmail.toLowerCase().includes(searchValue)
    //   );

    this.loadApplicationsWithSearch(searchValue);
  }

  loadApplicationsWithSearch(searchText: string) {
    const request: GetApplicationsForLinkingRequest = {
      inspectionId: this.inspectionId,
      clientId: this.context.client?.id,
      departmentId: this.departmentId,
      searchText,
      pageSize: this.pageSize,
      pageNumber: this.currentPage,
      sortField: this.sortField,
      sortDescending: this.sortDescending
    };

    this.workflowSvc.getApplicationsForLinking(request)
      .subscribe((res: any) => {
        const rows = res?.items || [];

        this.tableData = rows;
        this.filteredData = rows;
        this.totalRecords = res?.recordCount || rows.length;
      });
  }

  columns: TableColumn[] = [
    {
      key: 'applicationNumber',
      label: 'Application#',
      headerType: 'text',
      cellType: 'text',
      // hideMenu: true
    },
    {
      key: 'applicantName',
      label: 'Applicant',
      headerType: 'text',
      cellType: 'text',
      // hideMenu: true
    },
    {
      key: 'siteAddress',
      label: 'Site Address',
      headerType: 'text',
      cellType: 'text',
      // hideMenu: true
    },
    {
      key: 'applicantPhoneNumber',
      label: 'Applicant Phone Number',
      headerType: 'text',
      cellType: 'text',
      // hideMenu: true
    },
    {
      key: 'applicantEmail',
      label: 'Email',
      headerType: 'text',
      cellType: 'text',
      // hideMenu: true
    },
    {
      key: 'link',
      label: 'Link',
      headerType: 'text',
      cellType: 'component',
      // hideMenu: true,
      component: LinkIconComponent,
      componentInputs: (row) => ({ row }),
      componentOutputs: {
        linkClick: (row) => this.onLinkClick(row)
      }
    }
  ];

    loadInspectionDetails() {
  if (!this.inspectionId) return;

  this.workflowSvc.getInspectionJanus(this.inspectionId).subscribe({
    next: (res: any) => {

      this.linkedApplicationId = res?.linkedApplicationId || null;

      if (this.linkedApplicationId) {
        this.loadLinkedApplication(this.linkedApplicationId);
      } else {
        this.loadApplications();
      }
    },
    error: (err) => {
      console.error(err);
      this.loadApplications(); // fallback
    }
  });
}

  ngOnInit() {

    this.route.parent?.parent?.paramMap.subscribe(params => {
      this.departmentId = params.get('departmentId');
    });



    this.loadInspectionDetails();
  }

  private setDeleteConfirmModal(
    updates: Partial<CommonConfirmationModalData>
  ): void {
    this.deleteConfirmModal = {
      ...this.deleteConfirmModal,
      ...updates
    };
  }

  closeDeleteLinkedApplicationModal() {
    this.setDeleteConfirmModal({ open: false });
  }


  afterActionSuccess(linkedApplicationId?: string) {
    this.setDeleteConfirmModal({ open: false });


    this.loadLinkedApplication(linkedApplicationId);
  }
  confirmDeleteLinkedApplication() {
    if (!this.selectedRow) return;

    const isAlreadyLinked = this.selectedRow.workflowApplicationId === this.linkedApplicationId;
    if (isAlreadyLinked) {
      const request: UnlinkWorkflowApplicationRequest = {
        workflowApplicationId: this.applicationId,
        workflowApplicationIdToUnlink: this.selectedRow.workflowApplicationId
      };

      this.workflowSvc.unlinkWorkflowApplication(request)
        .subscribe(() => {
          this.linkedApplicationId = null;
          this.afterActionSuccess();
        });

    } else {
      const request: LinkWorkflowApplicationRequest = {
        workflowApplicationId: this.applicationId,
        workflowApplicationIdToLink: this.selectedRow.workflowApplicationId
      };


      this.workflowSvc.linkWorkflowApplication(request)
        .subscribe((res) => {
          const linkedId = res?.workflowApplicationId;

          this.afterActionSuccess(linkedId);
        });
    }


    // modal close
    this.setDeleteConfirmModal({ open: false });
  }
  onLinkClick(row: any) {
    this.selectedRow = row;
    const isLinked =
      row.workflowApplicationId === this.linkedApplicationId;
    this.setDeleteConfirmModal({
      open: true,
      modalDescp: isLinked
        ? 'Are you sure you want to unlink this application?'
        : 'Are you sure you want to link this application?',
      modalSubDescp: isLinked
        ? 'Clicking Confirm will unlink this inspection.'
        : 'Clicking confirm will link this inspection to the selected application.',
      replaceNoWith: 'CANCEL'
    });
  }

  onPageChange(page: number) {
    this.currentPage = page; // backend usually 1-based
    this.loadApplications();
    // this.applyPagination();
  }

  onPageSizeChange(size: number) {
    this.pageSize = size;
    this.currentPage = 1;
    this.loadApplications();
    // this.applyPagination();
  }

  onSortChange(event: any) {
    this.sortField = event.active;
    this.sortDescending = event.direction === 'desc';

    this.loadApplications();
    // this.applyPagination();
  }

  loadApplications() {
    const request: GetApplicationsForLinkingRequest = {
      inspectionId: this.inspectionId,
      clientId: this.context.client?.id,
      departmentId: this.departmentId,
      searchText: '',
      pageSize: this.pageSize,
      pageNumber: this.currentPage,
      sortField: this.sortField,
      sortDescending: this.sortDescending
    };

    this.workflowSvc.getApplicationsForLinking(request)
      .subscribe((res: any) => {

        const rows = res?.items || [];

        this.tableData = rows.map(item => ({
          ...item,
          isLinked: item.workflowApplicationId === this.linkedApplicationId
        }));


        if (this.linkedApplicationId) {
          // Show only linked application
          this.filteredData = rows.filter(
            item => item.workflowApplicationId === this.linkedApplicationId
          );
        } else {
          // Show all applications if nothing is linked
          this.filteredData = rows;
        }

        this.totalRecords = res?.recordCount || rows.length;
        this.totalPages = Math.ceil(this.totalRecords / this.pageSize);
      });
  }

  loadLinkedApplication(linkedApplicationId?: string) {

    if (!linkedApplicationId) {
      this.linkedApplicationId = null;

      this.loadApplications();
      return;
    }
    this.workflowSvc.getLinkedApplicationDetails(linkedApplicationId)
      .subscribe((res: any) => {

        this.linkedApplicationId = res?.workflowApplicationId || null;

        const linkedRow = {
          ...res,
          isLinked: true
        };

        this.tableData = [linkedRow];
        this.filteredData = [linkedRow];

        // pagination adjust
        this.totalRecords = 1;
        this.totalPages = 1;
      });
  }

}
